import { Component,OnInit,OnDestroy,AfterViewInit,ChangeDetectionStrategy,Pipe,PipeTransform } from '@angular/core';
import { NgbModal,NgbActiveModal,ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiAuthService
} from "src/app/shared/service";

@Component({
    selector: "user-info"
    ,templateUrl: "./user.info.component.html"
})
export class UserInfoComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    currentUserInfo:any={
        companyId: ""
        ,companyNm: ""
        ,ipAccessDevice: ""
        ,token: ""
        ,userGroupId: ""
        ,userGroupNm: ""
        ,userId: ""
        ,userNm: ""
        ,showMapCluster: true
    };
    ipAccessDevice:string;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService: FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.fvmsApiAuthService.getCurrentUserInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(currentUserInfo => {
                this.currentUserInfo = currentUserInfo;
            });

        this.fvmsApiAuthService.getIpAccessDevice()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(response => {
                if(response && response.ip){
                    this.ipAccessDevice = response.ip;
                }
            });
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
    }

    clickLogOut(){
        this.fvmsApiAuthService.signOut();
    }

    checkValue(currentUserInfo){
        this.fvmsApiAuthService.updateUserInfo(currentUserInfo)
        this.fvmsApiAuthService.setCurrentUserInfo(currentUserInfo)
    }
}
